

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class ScheduledReport_ManagedObject

class ScheduledReport_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: active
    set active(value:boolean) {
        this.setValueForKey(value, 'active');
    }
    get active():boolean {
        return this.valueForKey('active');
    }
    set activePrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'active');
    }
    get activePrimitiveValue():boolean {
        return this.primitiveValueForKey('active');
    }

    // Property: dayOfMonth
    set dayOfMonth(value:number) {
        this.setValueForKey(value, 'dayOfMonth');
    }
    get dayOfMonth():number {
        return this.valueForKey('dayOfMonth');
    }
    set dayOfMonthPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'dayOfMonth');
    }
    get dayOfMonthPrimitiveValue():number {
        return this.primitiveValueForKey('dayOfMonth');
    }

    // Property: emails
    set emails(value:string) {
        this.setValueForKey(value, 'emails');
    }
    get emails():string {
        return this.valueForKey('emails');
    }
    set emailsPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'emails');
    }
    get emailsPrimitiveValue():string {
        return this.primitiveValueForKey('emails');
    }

    // Property: format
    set format(value:string) {
        this.setValueForKey(value, 'format');
    }
    get format():string {
        return this.valueForKey('format');
    }
    set formatPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'format');
    }
    get formatPrimitiveValue():string {
        return this.primitiveValueForKey('format');
    }

    // Property: language
    set language(value:string) {
        this.setValueForKey(value, 'language');
    }
    get language():string {
        return this.valueForKey('language');
    }
    set languagePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'language');
    }
    get languagePrimitiveValue():string {
        return this.primitiveValueForKey('language');
    }

    // Property: lastError
    set lastError(value:string) {
        this.setValueForKey(value, 'lastError');
    }
    get lastError():string {
        return this.valueForKey('lastError');
    }
    set lastErrorPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'lastError');
    }
    get lastErrorPrimitiveValue():string {
        return this.primitiveValueForKey('lastError');
    }

    // Property: lastRunAt
    set lastRunAt(value:Date) {
        this.setValueForKey(value, 'lastRunAt');
    }
    get lastRunAt():Date {
        return this.valueForKey('lastRunAt');
    }
    set lastRunAtPrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'lastRunAt');
    }
    get lastRunAtPrimitiveValue():Date {
        return this.primitiveValueForKey('lastRunAt');
    }

    // Property: period
    set period(value:string) {
        this.setValueForKey(value, 'period');
    }
    get period():string {
        return this.valueForKey('period');
    }
    set periodPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'period');
    }
    get periodPrimitiveValue():string {
        return this.primitiveValueForKey('period');
    }

    // Property: recurrence
    set recurrence(value:string) {
        this.setValueForKey(value, 'recurrence');
    }
    get recurrence():string {
        return this.valueForKey('recurrence');
    }
    set recurrencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'recurrence');
    }
    get recurrencePrimitiveValue():string {
        return this.primitiveValueForKey('recurrence');
    }

    // Property: reportID
    set reportID(value:string) {
        this.setValueForKey(value, 'reportID');
    }
    get reportID():string {
        return this.valueForKey('reportID');
    }
    set reportIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'reportID');
    }
    get reportIDPrimitiveValue():string {
        return this.primitiveValueForKey('reportID');
    }

    // Property: sendTime
    set sendTime(value:string) {
        this.setValueForKey(value, 'sendTime');
    }
    get sendTime():string {
        return this.valueForKey('sendTime');
    }
    set sendTimePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'sendTime');
    }
    get sendTimePrimitiveValue():string {
        return this.primitiveValueForKey('sendTime');
    }

    // Property: title
    set title(value:string) {
        this.setValueForKey(value, 'title');
    }
    get title():string {
        return this.valueForKey('title');
    }
    set titlePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'title');
    }
    get titlePrimitiveValue():string {
        return this.primitiveValueForKey('title');
    }

    // Property: weekday
    set weekday(value:number) {
        this.setValueForKey(value, 'weekday');
    }
    get weekday():number {
        return this.valueForKey('weekday');
    }
    set weekdayPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'weekday');
    }
    get weekdayPrimitiveValue():number {
        return this.primitiveValueForKey('weekday');
    }
}
